import { render } from "./TransactionHistory.vue?vue&type=template&id=6d71bbcc"
import script from "./TransactionHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script